import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectFrontChatLauncherVisible, setLauncherVisible } from '../store';

/**
 * Hook that provides a clean API for controlling Front Chat FAB visibility
 * Can be used by other features to show/hide the chat launcher
 */
export const useFrontChatControl = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(selectFrontChatLauncherVisible);

  const showLauncher = useCallback(() => {
    dispatch(setLauncherVisible(true));
  }, [dispatch]);

  const hideLauncher = useCallback(() => {
    dispatch(setLauncherVisible(false));
  }, [dispatch]);

  const setLauncherVisibility = useCallback(
    (visible: boolean) => {
      dispatch(setLauncherVisible(visible));
    },
    [dispatch],
  );

  return {
    isVisible,
    showLauncher,
    hideLauncher,
    setLauncherVisibility,
  };
};